module.exports = __webpack_public_path__ + "static/pfb-logo-f45161a58c21f5d795591aa9b7ea2fff.png";